import React from 'react';
import Box from '@mui/material/Box';
import AutoStoriesRounded from '@mui/icons-material/AutoStoriesRounded';
import CheckRounded from '@mui/icons-material/CheckRounded';

export default function LibraryApprovalEmblem({ count, checked = false }) {
  return <Box className="library-approval-emblem" aria-hidden="true">
    <AutoStoriesRounded />
    <Box className="library-approval-emblem__badge">{checked ? <CheckRounded /> : count}</Box>
    <Box className="library-approval-emblem__spark library-approval-emblem__spark--one" />
    <Box className="library-approval-emblem__spark library-approval-emblem__spark--two" />
  </Box>;
}
